import { ProductItem } from '../types';

export const DEFAULT_PRODUCT_CATALOGUE: ProductItem[] = [
  {
    id: 'electrical-drives',
    categoryNumber: '01',
    category: 'Frequency Converters & Motion',
    title: 'ELECTRICAL DRIVES: VFD & SERVO',
    subTitle: 'SINAMICS Low-Voltage AC Inverters & High-Dynamic Servos',
    subtitle: 'SINAMICS Low-Voltage AC Inverters & High-Dynamic Servos',
    editorialTitle: 'Precision motion made seamless.',
    editorialSubtitle: 'A high-efficiency inverter & servo drive platform delivering sub-millisecond dynamic torque control with zero downtime.',
    descriptionPrompt: 'Products in Electrical Drives: VFD & SERVO are:',
    paragraphs: [
      'Simatech Automation is an authorized Siemens Channel Partner supplying, configuring, and commissioning the complete family of Siemens SINAMICS variable frequency drives (VFD) and high-dynamic servo drive converters. Engineered for low-voltage applications ranging from 0.12 kW up to 4,500 kW across 200V to 690V AC, the SINAMICS platform delivers unrivaled motor control efficiency, precision dynamic torque regulation, and maximum operational uptime across harsh industrial environments.',
      'Our product portfolio includes the compact SINAMICS V20 for straightforward pump, fan, and material handling tasks; the modular SINAMICS G120, G120C, G120P, and G120X series equipped with integrated Safe Torque Off (STO SIL 3 / PL e) and energy recovery; and the advanced SINAMICS S120 and S210 multi-axis coordinated servo drive systems. These systems communicate deterministically via PROFINET IRT and PROFIBUS DP, ensuring sub-millisecond motion synchronization.',
      'Simatech provides complete turnkey panel integration, drive sizing calculation, harmonic mitigation, regenerative Active Line Modules (ALM), and on-site FAT/SAT commissioning to guarantee seamless startup with zero plant disruption.',
    ],
    image: '/images/product/1.jpg',
    imageLeft: '/images/product/editorial/drive_left.jpg',
    imageRight: '/images/product/editorial/drive_right.jpg',
    detailLabel: 'Cooling Fin & Copper Terminal Macro',
    priceNote: 'Direct OEM Supply',
    iconType: 'drive',
    icon: 'Zap',
    badge: 'Flagship Drives',
    specs: [
      { label: 'Voltage Range', value: '200V - 690V AC' },
      { label: 'Power Range', value: '0.12 kW - 4,500 kW' },
      { label: 'Fieldbus', value: 'PROFINET IRT / PROFIBUS DP' },
      { label: 'Safety', value: 'SIL 3 / PL e (STO, SS1)' },
    ],
    models: [
      'SINAMICS G120C',
      'SINAMICS G120P',
      'SINAMICS G120',
      'SINAMICS V20',
      'SINAMICS S120',
      'SINAMICS G120X',
      'SINAMICS G130',
      'SINAMICS G110M',
      'SINAMICS G110D / G120D',
      'SINAMICS G150',
      'SINAMICS G180',
      'SINAMICS S150',
      'SINAMICS V90',
      'SINAMICS S210',
    ],
    modelsCol1: [
      'SINAMICS G120C',
      'SINAMICS G120P',
      'SINAMICS G120',
      'SINAMICS V20',
      'SINAMICS S120',
      'SINAMICS G120X',
      'SINAMICS G130',
    ],
    modelsCol2: [
      'SINAMICS G110M',
      'SINAMICS G110D / G120D',
      'SINAMICS G150',
      'SINAMICS G180',
      'SINAMICS S150',
      'SINAMICS V90',
      'SINAMICS S210',
    ],
    highlights: [
      'Multi-axis precision position synchronization',
      'High overload capacity with vector torque control',
      'Energy recovery with active line modules',
      'Seamless TIA Portal engineering integration',
    ],
    datasheetUrl: '/product',
  },
  {
    id: 'dc-drives',
    categoryNumber: '02',
    category: 'Direct Current Converters',
    title: 'DC DRIVES',
    subTitle: 'SINAMICS DC MASTER 6RA80 Digital Converters',
    subtitle: 'SINAMICS DC MASTER 6RA80 Digital Converters',
    editorialTitle: 'Heavy-duty power made dependable.',
    editorialSubtitle: 'Rugged digital DC converters engineered for continuous rolling mills, extruders, and demanding high-amperage modernization.',
    descriptionPrompt: 'Products we have in Direct Current Drives are:',
    paragraphs: [
      'The Siemens SINAMICS DC MASTER 6RA80 series represents the pinnacle of digital direct current drive converter engineering. Specially built for high-torque, heavy-overload industrial environments such as steel rolling mills, wire drawing plants, cable stranding machines, heavy rubber mixers, and mine hoists, the DC MASTER ensures rugged dependability where AC conversions are impractical or cost-prohibitive.',
      'Available for rated currents from 15 A up to 3,000 A (expandable up to 12,000 A in parallel configuration) and line voltages from 400V up to 950V AC, the 6RA80 supports both 2-quadrant and 4-quadrant fully regenerative operation. Control units (Standard CUD and Advanced CUD) feature integrated freely configurable closed-loop logic, dual-field excitation with dynamic field weakening, and native PROFINET/PROFIBUS fieldbus connectivity.',
      'Simatech Automation specializes in 1-to-1 retrofits of legacy SIMOREG 6RA24, 6RA70, and third-party analog DC converters, utilizing existing motor infrastructure while modernizing control cabinets with contemporary digital diagnostics and remote monitoring.',
    ],
    image: '/images/product/2.jpg',
    imageLeft: '/images/product/editorial/dc_drive_left.jpg',
    imageRight: '/images/product/editorial/dc_drive_right.jpg',
    detailLabel: 'Thyristor & Copper Busbar Macro',
    priceNote: '100% Commissioned',
    iconType: 'dc',
    icon: 'Gauge',
    badge: 'Heavy Mill Duty',
    specs: [
      { label: 'Rated Current', value: '15 A - 3,000 A' },
      { label: 'Supply Voltage', value: '400V - 950V AC' },
      { label: 'Quadrants', value: '2Q & 4Q Regenerative' },
      { label: 'Control Unit', value: 'Standard / Advanced CUD' },
    ],
    models: [
      'SINAMICS DC MASTER 6RA80',
    ],
    modelsCol1: [
      'SINAMICS DC MASTER 6RA80',
    ],
    highlights: [
      'Retrofit & modernization of legacy DC systems',
      'Dual-field controller with flux weakening range',
      'PROFIBUS DP & PROFINET multi-drop interfaces',
      'Rugged performance for rolling mills & heavy extruders',
    ],
    datasheetUrl: '/product',
  },
  {
    id: 'simatic-plc',
    categoryNumber: '03',
    category: 'Programmable Logic Controllers',
    title: 'SIMATIC PLC',
    subTitle: 'Advanced, Basic & Distributed Automation Controllers',
    subtitle: 'Advanced, Basic & Distributed Automation Controllers',
    editorialTitle: 'Next-gen logic made powerful.',
    editorialSubtitle: 'Ultra-fast modular automation controllers with integrated diagnostics, PROFINET deterministic bus, and hot-standby redundancy.',
    descriptionPrompt: 'Products we have in Simatic Programmable Logic Controller are:',
    paragraphs: [
      'Siemens SIMATIC programmable logic controllers (PLCs) form the core foundation of contemporary industrial manufacturing. Simatech Automation engineers, programs, and deploys the entire SIMATIC spectrum—from the economical S7-200 SMART and compact S7-1200 for stand-alone machine control, to the flagship SIMATIC S7-1500 modular automation system and high-availability S7-400H / S7-1500R/H fault-tolerant redundant controllers.',
      'Featuring ultra-fast bit processing speeds down to 1 nanosecond (CPU 1518), integrated system diagnostics with web visualization, built-in real-time trace functions, and fail-safe safety technology (SIL 3 / PL e), SIMATIC controllers deliver maximum productivity. Engineering is unified under Siemens TIA Portal (Totally Integrated Automation), enabling standardized code structures across LAD, FBD, SCL, and STL.',
      'Simatech provides complete software development, legacy S5/S7-300/S7-400 migration to TIA Portal S7-1500, cyber-secure communication architectures, and multi-CPU hot-standby redundancy for mission-critical continuous process operations.',
    ],
    image: '/images/product/3.jpg',
    imageLeft: '/images/product/editorial/plc_left.jpg',
    imageRight: '/images/product/editorial/plc_right.jpg',
    detailLabel: 'S7-1500 Diagnostic Display Macro',
    priceNote: 'TIA Portal Native',
    iconType: 'plc',
    icon: 'Cpu',
    badge: 'Unified Logic',
    specs: [
      { label: 'Cycle Time', value: 'Down to 1 ns (CPU 1518)' },
      { label: 'Programming', value: 'TIA Portal (LAD, FBD, SCL)' },
      { label: 'Security', value: 'Encrypted Communication' },
      { label: 'Architecture', value: 'Fail-Safe & High-Availability' },
    ],
    models: [
      'S7-200 SMART',
      'S7-1200 PLC',
      'S7-1500 PLC',
      'S7-300 PLC',
      'S7-400 PLC',
    ],
    modelsCol1: [
      'S7-200 SMART',
      'S7-1200 PLC',
      'S7-1500 PLC',
    ],
    modelsCol2: [
      'S7-300 PLC',
      'S7-400 PLC',
    ],
    highlights: [
      'Integrated system diagnostics with web visualization',
      'Integrated safety technology (Failsafe CPU)',
      'Motion control and high-speed counting on-board',
      'High-availability hot standby redundancy (H-CPU)',
    ],
    datasheetUrl: '/product',
  },
  {
    id: 'distributed-io',
    categoryNumber: '04',
    category: 'Decentralized Peripheral Stations',
    title: 'DISTRIBUTED I/O CONTROLLER/STATIONS',
    subTitle: 'SIMATIC ET-200 Scalable Remote Terminal Systems',
    subtitle: 'SIMATIC ET-200 Scalable Remote Terminal Systems',
    editorialTitle: 'Decentralized I/O made effortless.',
    editorialSubtitle: 'Tool-free push-in spring terminal architecture with hot-swappable modular slices for dense cabinet and field distribution.',
    descriptionPrompt: 'Products in Distributed I/O controller/stations are:',
    paragraphs: [
      'Siemens SIMATIC ET-200 distributed peripheral stations bring digital, analog, technology, and functional safety inputs/outputs directly to the field, substantially reducing control cabinet footprints and on-site field cabling costs. Simatech configures and commissions modular ET-200SP, ET-200MP, ET-200S, and ET-200M remote stations engineered for dense industrial distribution.',
      'The ET-200SP architecture features tool-free push-in spring terminals, hot-swappable module replacement during continuous operation (RUN), and flexible PROFINET BusAdapters supporting RJ45, FastConnect copper, and single/multimode fiber optics. Stations accommodate up to 64 modular slices with integrated energy meter cards for real-time power telemetry and motor starter modules directly on the rack.',
      'Our engineers design optimized decentralized architectures with IP20 cabinet-mount and IP65/IP67 field-mount modules, providing comprehensive channel diagnostics, wire-break detection, and tamper-resistant safety interlocking.',
    ],
    image: '/images/product/4.jpg',
    imageLeft: '/images/product/editorial/io_left.jpg',
    imageRight: '/images/product/editorial/io_right.jpg',
    detailLabel: 'Push-In Spring Clamp Macro',
    priceNote: 'IP20 / IP67 Rated',
    iconType: 'io',
    icon: 'Layers',
    badge: 'Push-In Terminals',
    specs: [
      { label: 'Channel Density', value: 'Up to 64 Modules / Station' },
      { label: 'Wiring System', value: 'Tool-free Push-In' },
      { label: 'Hot Swapping', value: 'Module Replacement in RUN' },
      { label: 'Protection', value: 'IP20 / IP65 / IP67' },
    ],
    models: [
      'SIMATIC ET 200SP (Active Generation)',
      'SIMATIC ET 200MP (Active Generation)',
      'SIMATIC ET 200S (Migration & Retrofit)',
      'SIMATIC ET 200M (Migration & Retrofit)',
    ],
    modelsCol1: [
      'SIMATIC ET 200SP (Active Generation)',
      'SIMATIC ET 200MP (Active Generation)',
    ],
    modelsCol2: [
      'SIMATIC ET 200S (Migration & Retrofit)',
      'SIMATIC ET 200M (Migration & Retrofit)',
    ],
    highlights: [
      'Compact footprint with high packaging density',
      'Flexible PROFINET bus adapters (RJ45, FastConnect, FO)',
      'Integrated fail-safe digital and analog cards',
      'Energy meter modules for real-time power logging',
    ],
    datasheetUrl: '/product',
  },
  {
    id: 'hmi',
    categoryNumber: '05',
    category: 'Operator Touch Terminals',
    title: 'HMI',
    subTitle: 'SIMATIC Key & Touch Panels for Plant Floor Machine Operation',
    subtitle: 'SIMATIC Key & Touch Panels for Plant Floor Machine Operation',
    editorialTitle: 'Machine control made tactile.',
    editorialSubtitle: 'Brilliant widescreen capacitive touch displays encased in IP65 die-cast aluminum for high-visibility factory floor supervision.',
    descriptionPrompt: 'Products we have in Human Machine Interface System are:',
    paragraphs: [
      'Siemens SIMATIC Human Machine Interface (HMI) operator panels deliver crisp, high-visibility visual supervision, operator guidance, recipe parameterization, and alarm handling directly on the plant floor. Simatech integrates the complete family of SIMATIC Basic Panels (KTP series), high-performance Comfort Panels (4" to 22" widescreen), and Mobile Panels with integrated safety emergency stop and deadman switches.',
      'Encased in rugged IP65 die-cast aluminum front bezels with scratch-resistant capacitive glass touchscreens, SIMATIC Comfort Panels operate with 16 million colors and ultra-wide 170-degree viewing angles. Featuring USB and SD card ports for automated recipe backups, integrated VNC server for remote plant supervision, and full compliance with FDA 21 CFR Part 11 electronic records for pharmaceutical and chemical operations.',
      'Simatech custom-crafts intuitive, ergonomic UI/UX graphics adhering to high-performance HMI standards, ensuring operators can detect anomalies, manage batch recipes, and navigate diagnostics with minimal cognitive load.',
    ],
    image: '/images/product/5.jpg',
    imageLeft: '/images/product/editorial/hmi_left.jpg',
    imageRight: '/images/product/editorial/hmi_right.jpg',
    detailLabel: 'Glass Touchscreen Interface Macro',
    priceNote: 'FDA 21 CFR Compliant',
    iconType: 'hmi',
    icon: 'Monitor',
    badge: 'Industrial Displays',
    specs: [
      { label: 'Screen Sizes', value: '4" to 22" Widescreen' },
      { label: 'Resolution', value: '16 Million Colors TFT' },
      { label: 'Front Bezel', value: 'IP65 Die-Cast Aluminum' },
      { label: 'Audit Trail', value: 'FDA 21 CFR Part 11' },
    ],
    models: [
      'SIMATIC KTP SERIES PANEL',
      'SIMATIC COMFORT PANEL',
      'SIMATIC MOBILE PANEL',
    ],
    modelsCol1: [
      'SIMATIC KTP SERIES PANEL',
      'SIMATIC COMFORT PANEL',
      'SIMATIC MOBILE PANEL',
    ],
    highlights: [
      'Brilliant wide viewing angle up to 170 degrees',
      'USB, SD card recipe storage & VNC remote client',
      'Mobile panel with integrated emergency stop & deadman',
      'End-to-end recipe and alarm archiving functions',
    ],
    datasheetUrl: '/product',
  },
  {
    id: 'scada',
    categoryNumber: '06',
    category: 'Plant Supervision & Historian',
    title: 'SCADA',
    subTitle: 'Supervisory Control, Historical Telemetry & Industrial PCs',
    subtitle: 'Supervisory Control, Historical Telemetry & Industrial PCs',
    editorialTitle: 'Plant supervision made clear.',
    editorialSubtitle: 'Enterprise-grade telemetry, real-time process historians, and Industrial PCs for plant-wide KPI analytics and OEE monitoring.',
    descriptionPrompt: 'Products in supervisory control and data acquisition (SCADA) are:',
    paragraphs: [
      'Simatech Automation designs and implements enterprise-level Supervisory Control and Data Acquisition (SCADA) systems and process historians based on Siemens SIMATIC WinCC Professional and WinCC Classic V7.x architectures running on industrial-grade SIMATIC Industrial PCs (IPC Rack, Box, and Panel PCs).',
      'Our SCADA systems scale from single-user supervisory stations to redundant multi-client distributed server topologies exceeding 256,000 process tags. The platform features high-performance Microsoft SQL database archiving, real-time Overall Equipment Effectiveness (OEE) telemetry, customized automated PDF batch shift reports, and secure web clients via WebNavigator and WebUX for remote mobile plant access.',
      'Equipped with OPC UA client/server protocols, our SCADA platforms bridge plant floor PLCs, drives, and instrumentation with higher-level ERP and MES enterprise systems for true Industry 4.0 data transparency.',
    ],
    image: '/images/product/6.jpg',
    imageLeft: '/images/product/editorial/scada_left.jpg',
    imageRight: '/images/product/editorial/scada_right.jpg',
    detailLabel: 'Real-Time Telemetry Curves Macro',
    priceNote: 'SQL Redundancy',
    iconType: 'scada',
    icon: 'Database',
    badge: 'Enterprise Telemetry',
    specs: [
      { label: 'Tag Capacity', value: 'Up to 256,000 Tags' },
      { label: 'Archiving', value: 'High-Performance MS SQL' },
      { label: 'Web Clients', value: 'WebNavigator & WebUX' },
      { label: 'Hardware', value: 'SIMATIC IPC Rack / Box' },
    ],
    models: [
      'SIMATIC WinCC Unified SCADA',
      'SIMATIC WinCC Professional (TIA Portal)',
      'SIMATIC WinCC V7 / V8 Enterprise',
      'SIMATIC Industrial PC (IPC Rack / Box / Panel)',
    ],
    modelsCol1: [
      'SIMATIC WinCC Unified SCADA',
      'SIMATIC WinCC Professional (TIA Portal)',
    ],
    modelsCol2: [
      'SIMATIC WinCC V7 / V8 Enterprise',
      'SIMATIC Industrial PC (IPC Rack / Box / Panel)',
    ],
    highlights: [
      'Plant-wide OEE, KPI monitoring & process analytics',
      'Redundant server architecture with automatic failover',
      'OPC UA client/server for Industry 4.0 cloud connectivity',
      'Audit trails, electronic signatures & batch reporting',
    ],
    datasheetUrl: '/product',
  },
  {
    id: 'motors',
    categoryNumber: '07',
    category: 'Electric & Servo Motors',
    title: 'MOTORS',
    subTitle: 'SIMOTICS Asynchronous & Synchronous Precision Servo Motors',
    subtitle: 'SIMOTICS Asynchronous & Synchronous Precision Servo Motors',
    editorialTitle: 'Dynamic torque made unstoppable.',
    editorialSubtitle: 'Synchronous and asynchronous industrial servo motors with 22-bit absolute optical encoders and sub-millimeter positioning.',
    descriptionPrompt: 'Products we have in Electric Motor are:',
    paragraphs: [
      'Siemens SIMOTICS electric and servo motors deliver exceptional dynamic acceleration, high energy efficiency, and mechanical durability across precision automation machinery. Simatech supplies, mechanically couples, and parameterizes SIMOTICS S synchronous servo motors (1FK7, 1FT7, 1FL6, and S210) and SIMOTICS M asynchronous main spindle motors (1PH8 series) up to 9,000 RPM.',
      'Equipped with high-resolution 22-bit absolute optical encoders, DRIVE-CLiQ digital feedback interfaces for automatic drive identification and parameterization, One Cable Connection (OCC) technology, and precision balancing up to vibration severity grade A. Available in shaft heights from SH 28 to SH 280 with IP65/IP67 environmental protection and forced-air or liquid cooling options.',
      'Simatech assists clients with mechanical inertia matching, torque-speed curve selection, precision planetary gearbox pairing, and closed-loop servo tuning to achieve vibration-free dynamic motion in high-speed converting, printing, and CNC operations.',
    ],
    image: '/images/product/7.jpg',
    imageLeft: '/images/product/editorial/motor_left.jpg',
    imageRight: '/images/product/editorial/motor_right.jpg',
    detailLabel: 'Keyed Rotor Shaft & Flange Macro',
    priceNote: 'DRIVE-CLiQ Ready',
    iconType: 'motor',
    icon: 'Activity',
    badge: 'High Dynamic Torque',
    specs: [
      { label: 'Rated Speed', value: 'Up to 9,000 RPM' },
      { label: 'Shaft Heights', value: 'SH 28 to SH 280' },
      { label: 'Feedback', value: '22-bit Absolute Encoder' },
      { label: 'Interface', value: 'DRIVE-CLiQ Digital' },
    ],
    models: [
      'ASYNCHRONOUS SERVO MOTOR 1PH8 SERIES',
      'SINAMICS V90 SERVO MOTOR 1FL6 SERIES',
      'SINAMICS S210 SERVO MOTOR',
      'SYNCHRONOUS SERVO MOTOR 1FK7 SERIES',
      'SYNCHRONOUS SERVO MOTOR 1FT7 SERIES',
    ],
    modelsCol1: [
      'ASYNCHRONOUS SERVO MOTOR 1PH8 SERIES',
      'SINAMICS V90 SERVO MOTOR 1FL6 SERIES',
      'SINAMICS S210 SERVO MOTOR',
    ],
    modelsCol2: [
      'SYNCHRONOUS SERVO MOTOR 1FK7 SERIES',
      'SYNCHRONOUS SERVO MOTOR 1FT7 SERIES',
    ],
    highlights: [
      'Maximum torque density with compact dimensions',
      'One Cable Connection (OCC) on modern servo lines',
      'High overload capability for rapid indexing and cutting',
      'Vibration severity grade A for ultra-smooth motion',
    ],
    datasheetUrl: '/product',
  },
];
